/* global window */

/**
 * Utility class for WordPress API functionality
 *
 */
export class WpApi {

	
	/**
	 * Send fetch request
	 *
	 * @param {object} data
	 * @param {string} endpointPath
	 * @param {string} method
	 * 
	 * @return {Promise}
	 */
	static async sendReq( data, endpointPath, method = 'GET' ) {
		let endpointUrl
		
		try {
			endpointUrl = new URL( window?.webfxPropertyManagerData?.restApiUrl )
		} catch( err ) {
			throw new Error( 'Invalid REST API URL' )
		}

		endpointUrl.pathname = `${endpointUrl.pathname}/${endpointPath}`

		const restApiNonce = window?.webfxPropertyManagerData?.restApiNonce

		if( !restApiNonce ) {
			throw new Error( 'Invalid REST API nonce' )
		}

		const headers = new Headers({
			'Content-Type': 'application/json',
			'X-WP-Nonce': restApiNonce,
		})

		const options = {
			method,
			headers
		}

		if( 'POST' === method ) {
			options.body = JSON.stringify( data )
		}
	
		const res = await fetch( endpointUrl.toString(), options )

		if( !res.ok ) {
			throw new Error( 'Failed to fetch.' )
		}

		return res.json()
	}

}
